export const IsProduction = process.env.NODE_ENV === 'production'

// localstorage
export const Authorization = 'Authorization'
export const AuthTimeout = 'AuthTimeout'
export const UserInfo = 'UserInfo'
export const Account = 'Account'

// http
export const URL = '/site'

// export const URL = 'https://api-test.kolacdn.xyz/site'
export const OK = 'ok'
export const Fail = 'fail'

export const RouterPaths = {
  home: '/payment',
  home_lite: '/payment_lite',
  "signin-email": '/payment/signin-email',
  "signin-email_lite": '/payment_lite/signin-email',
  "forget-email": '/payment/forget-email',
  "forget-email_lite": '/payment_lite/forget-email',
  "signin-phone": "/payment/signin-phone",
  "signin-phone_lite": "/payment_lite/signin-phone",
  "forget-phone": '/payment/forget-phone',
  "forget-phone_lite": '/payment_lite/forget-phone',
  "reset-password": "/payment/reset-password",
  "reset-password_lite": "/payment_lite/reset-password",
  "signin-qr": "/payment/signin-qr",
  "signin-qr_lite": "/payment_lite/signin-qr",

  menu: '/payment/menu',
  records: '/payment/menu/recharge-record',
  userInfo: '/payment/menu/user-info',
  settings: '/payment/menu/settings',
  CDKey:'/payment/menu/CDKey',
  equipment:'/payment/menu/equipment',
  camilo:'/payment/menu/camilo',
  delAccount:'/payment/menu/delAccount',
  router:'/payment/menu/router',
  notification:'/payment/menu/notification',

  myAffiliate: '/payment/affiliate',
  affiliateWithdrawRecords: '/payment/affiliate/withdraw-records',
  affiliateAwardRecords: '/payment/affiliate/award-records',
  thanksForUsing:'/payment/thanks-for-using',
  Activity:'/payment/activity',
  ActivityLite:'/payment_lite/activity',
  shop:'/payment/shop',
  shop_lite:'/payment_lite/shop',
  tv:'/payment/tv',
  invite: '/payment/invite',
  inviteRecords: '/payment/invite/records',
  inviteShare: '/payment/invite/share',

  lottery: '/payment/lottery',
  lotteryRecords: '/payment/lottery/records',
  lotteryRules: '/payment/lottery/rules'
}

export const baseUrl = IsProduction ? window.location.origin : 'https://test-site.tikvpn.in'


export const PARAM_KEYS = ['source', 'source_channel', 'source_app_version', 'source_package_name', 'place', 'spread']